import React from "react"
import { Block, FlexDirection } from "baseui/block"
import WysiwygRenderer from "./WysiwygRenderer"

type TextComboRendererProps = {
  content: string
  img: string
  align: string
}

const TextComboRenderer = ({ content, img, align }: TextComboRendererProps) => {
  const contentAlignment: FlexDirection[] =
    align === "right"
      ? ["column-reverse", "row-reverse", "row-reverse", "row-reverse"]
      : ["column", "row", "row", "row"]

  const isOnlyWysiwygContent = img === null
  const isOnlyImgContent = content === null

  return (
    <Block
      display={"flex"}
      flexDirection={contentAlignment}
      marginTop={["0px", "-30px", "0px", "0px"]}
      marginBottom={["0px", "-30px", "0px", "0px"]}
    >
      {img !== null && (
        <Block
          as={"img"}
          src={img}
          width={isOnlyImgContent ? "100%" : ["100%", "50%", "50%", "50%"]}
          height={"100%"}
          $style={{
            objectFit: "contain",
          }}
        />
      )}
      {content !== null && (
        <Block
          display={"flex"}
          alignItems={"center"}
          padding={isOnlyWysiwygContent ? "0px" : ["16px", "16px", "40px"]}
          width={isOnlyWysiwygContent ? "100%" : ["100%", "50%", "50%", "50%"]}
        >
          <WysiwygRenderer content={content} className={"text-combo"} />
        </Block>
      )}
    </Block>
  )
}

export default TextComboRenderer
